import { render, staticRenderFns } from "./sos-map.vue?vue&type=template&id=32148516&"
import script from "./sos-map.vue?vue&type=script&lang=js&"
export * from "./sos-map.vue?vue&type=script&lang=js&"
import style0 from "./sos-map.vue?vue&type=style&index=0&id=32148516&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports